import { httpClient } from '@/services/http/httpClient'

export type AccessStatsResponse = {
  usedSlots: number
  maxUsers: number | null
}

export async function getAccessStats(
  tennantId: string,
): Promise<AccessStatsResponse> {
  const { data } = await httpClient.get<AccessStatsResponse>(
    `/tennants/${tennantId}/access-stats`,
  )

  return data
}
